import { Component, Inject, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lang-switch',
  templateUrl: './lang-switch.component.html',
  styleUrls: ['./lang-switch.component.scss'],
})
export class LangSwitchComponent {
  constructor(
    private router: Router,
    @Inject(LOCALE_ID) public locale: string,
  ) {}

  setLocale(locale: string) {
    window.location.href = `/${locale}${this.router.url}`;
  }
}
